import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActionArea,
  useTheme,
} from "@mui/material";
import { getData } from "../utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function TagCard(props) {
  const { image, imageId, title, permalink } = props.tag;

  const theme = useTheme();
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    const go = async () => {
      setPhoto(null);

      if (image?.cloudFrontDomain) {
        setPhoto(
          `${image.cloudFrontDomain}${
            image.sizes?.small ||
            image.sizes?.medium ||
            image.sizes?.large ||
            image.filename
          }`
        );
      } else if (imageId) {
        try {
          let apiPhoto = await getData(`/files/${imageId}`);
          setPhoto(apiPhoto);
        } catch (err) {
          console.log(err);
        }
      } else {
        setPhoto(
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImage${
            theme?.palette?.mode === "dark" ? "Dark" : ""
          }.png`
        );
      }
    };

    go();
    // eslint-disable-next-line
  }, [props]);

  return (
    <Card sx={{ height: "100%" }}>
      <CardActionArea href={`/news/${permalink}`}>
        <CardMedia
          component="img"
          image={photo?.url || photo}
          title={title}
          alt={title}
          sx={{
            maxHeight: "calc((100vw - 24px) * 0.5625)",
            "@media (min-width: 600px)": {
              maxHeight: "calc((100vw - 24px) * 0.5 * 0.5625)",
            },
            "@media (min-width: 900px)": {
              maxHeight: "calc((100vw - 24px) * 0.3333 * 0.5625)",
            },
            "@media (min-width: 1218px)": {
              maxHeight: "215px",
            },
            pt: 2,
            pr: 2,
            pl: 2,
            pb: 1,
          }}
        />

        <CardContent sx={{ pb: 1, pt: 0 }}>
          <Typography sx={{ textAlign: "center" }} variant="h4" component="p">
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
